export function determinePageAssetId(page) {
    return page.UserResponseId !== undefined ? page.UserResponseId : page.PageAssetId;
}
